// Import Packages
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import { Select, MenuItem } from '@material-ui/core';
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

// Import Components
import { Condition } from '../../../../../FlowConfigurationInputs/ConditionModal/ConditionModal'
import ConfigurationForm from '../../../../index'

const useStyles = makeStyles((theme) => ({
    header: {
        justifyContent: 'space-between',
        color: 'white',
        backgroundColor: 'var(--black-pearl)',
        fontSize: '12px',
        padding: '8px'
    }
}));

const actionNames = [
    { value: 'REPLACE', label: 'Replace', type: 'string' },
    { value: 'TRIM', label: 'Trim', type: 'string' }
]

export const actionList = {
    REPLACE: {
        libraryName: 'STRING',
        actionName: 'REPLACE',
        fields: {
            sourceString: { value: '##-##', defaultValue: true },
            set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
        },
        isDebugging: false,
        name: 'REPLACE'
    },
    TRIM: {
        libraryName: 'STRING',
        actionName: 'TRIM',
        fields: {
            sourceString: { value: '##-##', defaultValue: true },
            set: { value: '-', type: 'VARIABLEPICKER', defaultValue: true }
        },
        isDebugging: false,
        name: 'TRIM'
    }
}

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

function Action({ actions, outputVariable, setActions, index, variables, setOpenVariable, variableRender, valueType }) {
    const { t } = useTranslation();

    const [hasCondition, setHasCondition] = useState(false);
    const [actionName, setActionName] = useState('');
    const [selectedAction, setSelectedAction] = useState(null);
    const [conditions, setConditions] = useState([]);
    const classes = useStyles();
    const conditionBackup = useRef();

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    const changeSelectedAction = (name) => {
        let selectedAction = JSON.parse(JSON.stringify(actionList[name]))
        Object.keys(selectedAction.fields).forEach((key) => {
            if (selectedAction.fields[key].defaultValue) {
                selectedAction.fields[key].value = selectedAction.fields[key].value.replace('-', outputVariable);
            }
        })
        setSelectedAction(selectedAction);
        return selectedAction;
    }

    useEffect(() => {
        if (actions[index].name) {
            if (actions[index].name === 'CONDITION') { // has condition true
                setHasCondition(true);
                setConditions(actions[index].children[0].fields.conditions.value); // set conditions
                if (actions[index].children && actions[index].children[0].children[0]) {
                    setSelectedAction(actions[index].children[0].children[0]);
                    setActionName(actions[index].children[0].children[0].name);
                }
            } else {
                setSelectedAction(actions[index]);
                setActionName(actions[index].name);
            }
        }
    }, []);

    const changeHasCondition = (checked) => {
        setHasCondition(!hasCondition)
        let actionData = [...actions];
        if (checked) {
            let c = []
            if (conditions.length < 1) {
                c = addCondition(true);
            } else {
                c = [...conditions];
            }
            let condition = {
                "flow": "rowCol",
                "name": "CONDITION",
                "type": "condition",
                "children": [
                    {
                        "name": "IF",
                        "type": "groupable",
                        "fields": { conditions: { type: "CONDITION", value: c } },
                        "children": [],
                        "actionName": "IF",
                        "action_name": "IF",
                        "isDebugging": false,
                        "libraryName": "CONDITION",
                        "action_label": "IF",
                        "libraryLabel": "CONDITION",
                        "library_name": "CONDITION",
                        "library_label": "CONDITION",
                        "conditionGroupId": "8b26a530-6e34-4b96-b506-3e40d44f99f9"
                    }
                ],
                "action_name": "CONDITION",
                "flow_behavior": [
                    "vertical",
                    "groupable"
                ]
            }
            if (actionData[index].name && actionData[index].name !== 'CONDITION') {
                condition.children[0].children.push(actionData[index]);
            }
            actionData[index] = condition;
            setActions(actionData);

        } else {
            if (actionData[index].name) {
                if (actionData[index].name === 'CONDITION') {
                    if (actionData[index].children[0].children.length > 0) {
                        actionData[index] = actionData[index].children[0].children[0]
                    } else {
                        actionData[index] = {};
                    }
                    setActions(actionData);
                }
            }
        }
    }

    const addCondition = (fromChangeHasCondition) => {
        let c = [...conditions];
        if (c.length) {
            c[c.length - 1].logic = 'and';
        }
        const newCondition = {
            logic: "last",
            fields: {
                firstValue: {
                    value: ''
                },
                secondValue: {
                    value: ''
                },
                caseSensitive: {
                    value: false
                }
            },
            operator: "eq",
            condition: "string",
            firstBool: true,
            secondBool: true
        }
        c.push(newCondition);
        setConditions(c);
        if (fromChangeHasCondition) {
            return c;
        } else {
            setActionCondition(c);
        }

    }

    // set condition field in actions
    const setActionCondition = (c) => {
        let actionData = [...actions]
        actionData[index].children[0].fields.conditions.value = c;
        setActions(actionData);
    }

    const removeCondition = (i) => {
        let c = [...conditions];
        c.splice(i, 1);
        c[c.length - 1].logic = 'last'
        setConditions(c)
        setActionCondition(c);
    }

    const updateAction = (value) => {
        setActionName(value);

        let actionData = [...actions];
        const data = changeSelectedAction(value);
        if (hasCondition) {
            if (actionData[index].children[0].children.length > 0) {
                actionData[index].children[0].children[0] = data;
            } else {
                actionData[index].children[0].children.push(data);
            }
        } else {
            actionData[index] = data;
        }

        setActions(actionData);
    }

    const removeAction = () => {
        let actionData = [...actions];
        actionData.splice(index, 1);
        setActions(actionData)
    }

    const handleLogicChange = (logic, i) => {
        let c = [...conditions];
        c[i].logic = logic;
        setConditions(c);
        setActionCondition(c);
    }

    // set action field
    const setField = (inputName, value) => {
        let actionData = [...actions];
        if (hasCondition && actionData[index].children) {
            actionData[index].children[0].children[0].fields[inputName] = value;
        } else {
            actionData[index].fields[inputName] = value;
        }
        setActions(actionData)
    }

    // set condition fields
    const setConditionField = (conditionIndex, fieldName, value) => {
        let c = [...conditions]
        if (fieldName === 'operator' || fieldName === 'condition') {
            c[conditionIndex][fieldName] = value;
        } else {
            c[conditionIndex].fields[fieldName] = value;
        }
        setConditions(c);
        setActionCondition(c);
    }

    return (
        <div style={{ padding: '2%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Select value={actionName} onChange={(e) => updateAction(e.target.value)} variant="outlined"
                    style={{ backgroundColor: '#FAFAFA', width: '100%' }}>
                    {
                        actionNames.filter(x => x.type === valueType).length < 1 &&
                        <MenuItem disabled key={""} value={""}>No action found for the selected type</MenuItem>
                    }
                    {
                        actionNames.filter(x => x.type === valueType).map((item, itemI) =>
                            <MenuItem key={itemI} value={item.value}>{item.label}</MenuItem>
                        )
                    }
                </Select>
                {
                    index !== 0 && (
                        <IconButton color={'black'} onClick={removeAction}>
                            <IndeterminateCheckBoxIcon style={{ marginLeft: '2%' }} />
                        </IconButton>
                    )
                }
            </div>
            <div style={{ marginTop: '3%' }}>
                {
                    selectedAction && (
                        <ConfigurationForm disabled={true} setField={setField} selectedAction={selectedAction}
                            variables={variables}
                            setOpenVariable={setOpenVariable} variableRender={variableRender} />
                    )
                }
            </div>
            {
                selectedAction && <div style={{ marginBottom: '2%' }}>
                    <FormControlLabel
                        control={<GreenCheckbox name="checkedG" checked={hasCondition}
                            onChange={(e) => changeHasCondition(e.target.checked)} />}
                        label={t(label + 'CONDITION-QUESTION')}
                    />
                    {
                        hasCondition && <IconButton color={'black'} onClick={() => addCondition(false)}>
                            <AddCircleIcon />
                        </IconButton>
                    }
                </div>
            }
            {
                hasCondition &&
                conditions.map((conditionInfo, conditionIndex) => (
                    <div>
                        <Card style={{ backgroundColor: 'var(--black-pearl)', boxShadow: 'none' }}>
                            <CardHeader className={classes.header} titleTypographyProps={{ variant: '' }}
                                title={`${t(label + 'CONDITION')} # ${conditionIndex + 1}`}
                                action={
                                    conditionIndex !== 0 && <IconButton style={{ color: 'white' }}
                                        onClick={() => removeCondition(conditionIndex)}>
                                        <DeleteOutlineOutlinedIcon />
                                    </IconButton>
                                }
                            />
                            <CardContent style={{ backgroundColor: '#ebecee' }}>
                                <Condition conditionBackup={conditionBackup} conditionInfo={conditionInfo}
                                    variables={variables} setOpenVariable={setOpenVariable}
                                    variableRender={variableRender} setField={(key, value) => {
                                        setConditionField(conditionIndex, key, value)
                                    }} />
                            </CardContent>
                        </Card>
                        {
                            conditionInfo.logic !== 'last' &&
                            <div className="form-element" style={{ textAlign: 'center' }}>
                                <div className="condition-tabs">
                                    <button className={conditionInfo.logic === 'and' ? 'condition-active' : ''}
                                        value="and" onClick={(e) => {
                                            handleLogicChange('and', conditionIndex)
                                        }}>
                                        {t(label + 'AND')}
                                    </button>
                                    <button className={conditionInfo.logic === 'or' ? 'condition-active' : ''}
                                        value="or" onClick={(e) => {
                                            handleLogicChange('or', conditionIndex)
                                        }}>
                                        {t(label + 'OR')}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                ))
            }
        </div>
    )
}

export default Action;
